export enum GENDER_TYPE {
  MALE = 'M',
  FEMALE = 'F',
}
